module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-fontawesome-css/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Krista Naso Personal Portfolio","short_name":"KN Portfolio","start_url":"/","background_color":"#f7f0eb","theme_color":"#a2466c","description":"The personal portfolio of Krista Naso a Front End Developer from the Chicago Area. View projects, recommendations, and proficient technologies!","lang":"en","display":"standalone","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"883255be09fc9b774046559aebcb8820"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
